import ApiRouteProvider from '../route'
import axios from '@axios'

export default {
    user: {
        currentSubscriber: {
            reindexUsers() {
                return axios.post(
                    ApiRouteProvider.getBaseUrl() + '/internal-tools/user/current-subscriber/reindex',
                    {}
                )
            },
        },
    },

    product: {
        supplierReplyReview: {
            run(supplierId, documents) {
                const form = new FormData()
                form.append('supplierId', supplierId)
                Array.from(documents).forEach(document => {
                    form.append('documents[]', document)
                })

                return axios.post(
                    ApiRouteProvider.getBaseUrl() + '/internal-tools/product/supplier-reply-review',
                    form
                )
            },
        },
    },
}
